<template>
    <div class="app-wrapper" :class="classObj">
        <sidebar ></sidebar>
        <div class="main-container">
            <app-main></app-main>
        </div>
    </div>
</template>

<script>
    import Sidebar from './components/Sidebar'
    import AppMain from './components/AppMain'

    export default {
        name: 'layout',
        components: {
            Sidebar,
            AppMain
        },
        computed: {
            sidebar() {
                return this.$store.state.app.sidebar
            },
            classObj() {
                return {
                    hideSidebar: !this.sidebar.opened,
                    withoutAnimation: this.sidebar.withoutAnimation,
                }
            }
        },
        methods: {}
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    @import "src/styles/mixin.scss";

    .app-wrapper {
        @include clearfix;
        position: relative;
        height: 100%;
        width: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue